const i = (t, e) => {
  const n = Object.getPrototypeOf(t), r = Object.getOwnPropertyDescriptor(t, "value"), c = Object.getOwnPropertyDescriptor(
    n,
    "value"
  );
  if (r != null && r.set && (c != null && c.set)) {
    const o = r.set, s = c.set;
    o !== s ? s.call(t, e) : o.call(t, e);
  }
};
function u(t, e) {
  if (!t) return;
  const n = document.createEvent("HTMLEvents");
  return n.initEvent(e, !0, !0), !t.dispatchEvent(n);
}
export {
  u as fireEvent,
  i as setNativeValue
};
